// src/pages/Dashboard/Admin/DepensesRecettesDashboard/components/EmptyOperationsState.jsx

import React from "react";
import { FaPlus, FaReceipt } from "react-icons/fa";

export default function EmptyOperationsState({ onAdd }) {
  return (
    <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 p-10 text-center dark:border-slate-700 dark:bg-slate-900/60">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-950 text-white dark:bg-white dark:text-slate-950">
        <FaReceipt className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucune opération trouvée
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
        Ajoutez une première opération ou ajustez les filtres pour retrouver les
        lignes déjà saisies.
      </p>

      <button
        type="button"
        onClick={onAdd}
        className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-slate-950 px-4 py-2 text-sm font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
      >
        <FaPlus />
        Ajouter une opération
      </button>
    </div>
  );
}